import Icon from '../components/Icon.vue'

Icon.register({"bookmark-o":{"width":1280,"height":1792,"paths":[{"d":"M1152 256h-1024v1242l423-406 89-85 89 85 423 406v-1242zM1164 128q23 0 44 9 33 13 52.5 41t19.5 62v1289q0 34-19.5 62t-52.5 41q-19 8-44 8-48 0-83-32l-441-424-441 424q-36 33-83 33-23 0-44-9-33-13-52.5-41t-19.5-62v-1289q0-34 19.5-62t52.5-41q21-9 44-9h1048z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/bookmark-o.js
// module id = 386
// module chunks = 0